import { createUseStyles } from "react-jss";
import { darken, brighten } from "../../../theme/Mixins";

const questionColor = ({ selected, simulated, active }) => {
    let color = "#117297";
    if (simulated) color = "#70bbd8";
    if (active) color = "#00A9E8";
    if (selected) return darken(color, 0.7);
    return color;
};

export default createUseStyles({
    blockStart: {
        margin: [[12, 0]],
        backgroundImage:
            "url(data:image/gif;base64,R0lGODlhAQABAJEAAAAAAP///9/f3////yH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAADACwAAAAAAQABAAACAlQBADs=);",
        backgroundPosition: "center center",
        backgroundRepeat: "repeat-x",
        textAlign: "center",

        "& span": {
            display: "inline-block",
            position: "relative",
            padding: [[0, 15]],
            top: -1,
            lineHeight: "20px",
            fontSize: "13px",
            fontWeight: 900,
            maxWidth: "60%",
            background: "white",
        },
    },
    pageBreak: {
        margin: [[12, 0]],
        backgroundImage:
            "url(data:image/gif;base64,R0lGODlhBQABAJEAAAAAAP///9/f3////yH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAADACwAAAAABQABAAACA5Q3BQA7)",
        backgroundPosition: "center center",
        backgroundRepeat: "repeat-x",
        textAlign: "center",

        "& span": {
            color: "#919191",
            display: "inline-block",
            position: "relative",
            padding: [[0, 15]],
            top: -1,
            lineHeight: "20px",
            fontSize: "11px",
            fontWeight: 700,
            maxWidth: "60%",
            background: "white",
        },
    },
    flowQuestionContainer: {
        position: "relative",
        margin: [[6, 0]],
        paddingRight: 35,
    },
    flowQuestion: {
        composes: "flow-question",
        display: "inline-block",
        background: questionColor,
        color: "white",
        fontSize: "13px",
        padding: [[4, 12]],
        borderRadius: 5,
        wordBreak: "break-word",
        transition: "background 200ms, color 200ms",

        "& .bg-color": {
            questionColor,
            transition: "color 200ms",
        },
    },
    flowQuestionIcon: {
        marginRight: 12,
        fontSize: "14px",
    },
    flowQuestionActions: {
        position: "absolute",
        top: 0,
        right: -4,
    },
    flowQuestionAction: {
        padding: 4,
        paddingLeft: 2,
        fontSize: "14px",
        userSelect: "none",
    },
    flowQuestionActionButton: {
        cursor: "pointer",
    },
    flowQuestionActionActive: {
        color: "#00A9E8",
    },
    flowQuestionLogic: {
        borderRadius: 5,
        background: (props) => darken(questionColor(props), 0.5),
        transition: "background 200ms, color 200ms",
        padding: [[4, 8]],
        margin: [[4, 0]],
        fontSize: "10px",
        color: (props) => brighten(questionColor(props), 3),
    },
    flowQuestionLogicIcon: {
        marginRight: 6,
    },
    flowPage: {
        position: "relative",
    },
    flowPageSelectArea: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 40,
        bottom: 0,
        cursor: "pointer",
        userSelect: "none",
    },
    questionConnector: {
        position: "absolute",
        bottom: "100%",
        left: 18,
        width: 4,
        height: 6,
        background: questionColor,
        transition: "background 200ms",
    },
});
